import(/* webpackMode: "eager" */ "/app/apps/web/app/[locale]/(with-main-layout)/(authorized)/(withFooter)/page.client.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/web/i18n/index.ts");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@14.2.18_@babel+core@7.26.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@14.2.18_@babel+core@7.26.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
